import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ToolPage from "@/pages/ToolPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Compare from "@/pages/Compare";
import Developers from "@/pages/Developers";
import EmbedMarketing from "@/pages/EmbedMarketing";
import EmbedTool from "@/pages/EmbedTool";
import { Privacy, Terms, About, Contact } from "@/pages/StaticPages";
import Admin from "@/pages/Admin";
import Partners from "@/pages/Partners";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { useLocation } from "react-router-dom";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isEmbed = pathname.startsWith('/embed/'); // /embed marketing page keeps chrome; /embed/:id iframe does not
  const isAdmin = pathname.startsWith('/admin');
  if (isEmbed) return <main>{children}</main>;
  if (isAdmin) return <main className="min-h-screen bg-zinc-50">{children}</main>;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tools/:toolId" element={<ToolPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/vs/:slug" element={<Compare />} />
            <Route path="/developers" element={<Developers />} />
            <Route path="/embed" element={<EmbedMarketing />} />
            <Route path="/embed/:toolId" element={<EmbedTool />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Chrome>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              border: '2px solid #0A0A0A',
              boxShadow: '4px 4px 0 0 #0A0A0A',
              borderRadius: 0,
              fontFamily: 'IBM Plex Sans, sans-serif',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
